import React, { useState } from "react";
import { Button, Checkbox, TableCell, TableRow, Tooltip } from "@mui/material";
import { Restore as RestoreIcon, Visibility as VisibilityIcon, Edit as EditIcon, Delete as DeleteIcon, Replay as  ReplayIcon} from "@mui/icons-material";
import { ActionPerformed } from "../../../../shared_elements/components";
import LessMoreComp from "../../../../shared_elements/components/CustomLessMoreComp";
import { PermissionWrapper } from "../../../../wrappers";
import { trackActivity } from "../../../../utils/mixpanel";
import AuditPopover from "../../../../shared_elements/components/popover";
import MoreVertIcon from '@mui/icons-material/MoreVert';

const AccountTypeList = ({ toggleBulkOps, item, onEditFn, viewRevisonHistory, ondeleteAccountType, onView, bulk,onRestore }) => {
  const isInActive = item?.is_deleted === true ? true: false;

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Rate Account Types Listing`, page_type: page_type, })
    }
    return (
        <TableRow>
            <TableCell className="table-actions-list">
                <div className="table-icon-container">
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "rate_account_type", operationType: ['D'] }}>
                        <Checkbox style={{ verticalAlign: 'super' }} color="primary" size="small" checked={bulk?.ids.find(items => items?.id === item?.id) ? true : false} onChange={(e) => toggleBulkOps(e.target.checked, 'single', item)} disabled={isInActive} />
                    </PermissionWrapper>
                    <AuditPopover item={item}>
                        <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
                    </AuditPopover>
                    <Tooltip title="Revision History"> <RestoreIcon className="revision-history" onClick={() => { viewRevisonHistory(); handleItemClicked('RevisionHistoryIcon') }} fontSize="small" color="primary" sx={{ cursor: "pointer" }} /> </Tooltip>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "rate_account_type", operationType: ['R'] }}>
                        <Tooltip title="View"> <VisibilityIcon fontSize="small" color="primary" onClick={() => { onView(); handleItemClicked('ViewIcon') }} sx={{ cursor: "pointer" }} /> </Tooltip>
                    </PermissionWrapper>
                    {item?.is_deleted ?
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "rate_account_type", operationType: ['U'] }}>
                            <Tooltip title="Restore"> <ReplayIcon fontSize="small" color="primary" onClick={() => { onRestore(); handleItemClicked('RevertIcon') }} sx={{ cursor: "pointer" }} /> </Tooltip>
                        </PermissionWrapper> :
                        <>
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "rate_account_type", operationType: ['U'] }}>
                                <Tooltip title="Edit"> <EditIcon fontSize="small" color="primary" onClick={() => { onEditFn(); handleItemClicked('EditIcon') }} sx={{ cursor: "pointer" }} /> </Tooltip>
                            </PermissionWrapper>
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "rate_account_type", operationType: ['D'] }}>
                                <Tooltip title="Delete"> <DeleteIcon fontSize="small" color="error" onClick={() => { ondeleteAccountType(); handleItemClicked('DeleteIcon') }} sx={{ cursor: "pointer" }} /> </Tooltip>
                            </PermissionWrapper>
                        </>}
                </div>
            </TableCell>
            <TableCell sx={{ color: isInActive ? '#00000061 !important' : 'inherit', cursor: 'pointer' }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}><div style={{ width: item?.name?.length > 45 ? "200px" : ''}}><LessMoreComp name={item?.name || "--"} lessMr='name' /></div></TableCell>
            <TableCell sx={{ color: isInActive ? '#00000061 !important' : 'inherit', cursor: 'pointer' }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}>{item?.applicable_for?.label ? item?.applicable_for?.label : "--"}</TableCell>
            <TableCell sx={{ color: isInActive ? '#00000061 !important' : 'inherit', cursor: 'pointer' }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}>
                <Button
                    variant="contained"
                    sx={{
                        backgroundImage:isInActive ? 'linear-gradient(90deg, #d3d3d3, #ececec 95%)' : item?.status ? "linear-gradient(90deg,#beed87,#d2e9b6 95%)" : "linear-gradient(269deg,#fadfb8,#fdd79e 95%)",
                        color: isInActive ? '#00000061 !important' : item?.status ? '#5ec264' : '#ff9800',
                        textTransform: "capitalize",
                        padding: "0 6px",
                        fontWeight: "600",
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                        justifyContent: "center",
                        cursor: 'default',
                    }}
                >
                    {item?.status ? 'Active' : "Inactive"}
                </Button>
            </TableCell>
            <TableCell sx={{ color: isInActive ? '#00000061 !important' : 'inherit', cursor: 'pointer' }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}><LessMoreComp name={item?.remarks} lessMr="remarks" /></TableCell>
        </TableRow>
    );
};

export default AccountTypeList;
